module.exports = __webpack_public_path__ + "img/35.9e402a63.png";